export default "__VITE_PUBLIC_ASSET__00ea1c3f__"